import { TableFieldType, TableHeader } from "helix-vue-components";

export const ThirdPartyTableHeaders: TableHeader[] = [
  {
    label: "",
    value: "name",
    fieldComponent: TableFieldType.string
  }
];
